import { render, staticRenderFns } from "./PriceGroups.vue?vue&type=template&id=55c5c9f8&scoped=true"
import script from "./PriceGroups.vue?vue&type=script&lang=js"
export * from "./PriceGroups.vue?vue&type=script&lang=js"
import style0 from "./PriceGroups.vue?vue&type=style&index=0&id=55c5c9f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c5c9f8",
  null
  
)

export default component.exports